import Vue from 'vue'
import BaseAlert from './components/BaseAlertInline'
import BaseCheckbox from './components/BaseCheckbox'
import BaseCheckboxesList from './components/BaseCheckboxesList'
import BaseRadioList from './components/BaseRadioList'
import BaseInput from './components/BaseInput'
import BaseInputPhone from './components/BaseInputPhone'
import BasePreloader from './components/BasePreloader'
import BaseSvg from './components/BaseSvg'
import BaseSelect from './components/BaseSelect'
import BaseHelp from './components/BaseHelp'
import BaseImage from './components/BaseImage'
import BaseAvatar from './components/BaseAvatar'
import BaseTooltip from './components/BaseTooltip'
import BaseMenu from './components/menu/BaseMenu'
import TagsSelector from './components/tags-selector/TagsSelector'

Vue.component('BaseAlert', BaseAlert)
Vue.component('BaseCheckbox', BaseCheckbox)
Vue.component('BaseCheckboxesList', BaseCheckboxesList)
Vue.component('BaseRadioList', BaseRadioList)
Vue.component('BaseInput', BaseInput)
Vue.component('BaseInputPhone', BaseInputPhone)
Vue.component('BasePreloader', BasePreloader)
Vue.component('BaseSvg', BaseSvg)
Vue.component('BaseSelect', BaseSelect)
Vue.component('BaseHelp', BaseHelp)
Vue.component('BaseImage', BaseImage)
Vue.component('BaseAvatar', BaseAvatar)
Vue.component('BaseTooltip', BaseTooltip)
Vue.component('BaseMenu', BaseMenu)
Vue.component('TagsSelector', TagsSelector)
